import React from "react";
import "./button.css";

interface ButtonProps {
  children: React.ReactNode;
  backgroundColor?: string;
  transparent?: boolean;
  onClick?: () => void;
}

const Button: React.FC<ButtonProps> = ({
  children,
  backgroundColor = "var(--color-blue)",
  transparent = false,
  onClick,
}) => {
  return (
    <button
      className={`button-base ${
        transparent ? "button-transparent" : "button-solid"
      }`}
      style={
        {
          "--button-bg-color": backgroundColor,
        } as React.CSSProperties
      }
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
